import React, {HTMLProps} from 'react'
import {Alert, AlertIcon, AlertTitle} from "@chakra-ui/react";

const CustomLink: React.FC<HTMLProps<HTMLAnchorElement>> = (props) => {
  const href = props.href;
  const isInternalLink = href && (href.startsWith('/') || href.startsWith('#'));
  const classes = 'text-blue-700';

  if (isInternalLink) {
    return (
      <Alert status="error">
        <AlertIcon />
        <AlertTitle mr={2}>Internal links aren't implemented yet!</AlertTitle>
      </Alert>
    )
  }

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      {...props}
      className={classes}
    />
  )
}

export default CustomLink
